export const updatePurchaseList = (state, payload) => {
  state.purchaseList = payload
}

export const fetchPurchaseInfo = (state, payload) => {
  state.purchaseInfo = payload
}

export const fetchUnClosedPurchaseCount = (state, payload) => {
  state.unClosedPurchaseCount = payload
}

export const fetchUnPaidPurchaseCount = (state, payload) => {
  state.unPaidPurchaseCount = payload
}
